<div *ngIf="!note" fxLayout="column" fxLayoutAlign="center center" fxFlex>
  <mat-icon class="s-128 mb-16 select-message-icon" *fuseIfOnDom>
    note
  </mat-icon>
  <span class="select-message-text hint-text" *fuseIfOnDom>
    <span>Select a note to read</span>
  </span>
</div>

<div *ngIf="note">
  <note-detail-item
    class="h-100-p"
    [note]="note"
    [readOnly]="readOnly"
    (onPrint)="print()"
  ></note-detail-item>
</div>

<div *ngIf="editable && !readOnly">
  <button
    id="btnEdit"
    mat-fab
    class="edit-button mat-accent"
    matTooltip="Edit Note"
    (click)="edit()"
    aria-label="Edit Note"
    *fuseIfOnDom
  >
    <mat-icon style="color: white">edit</mat-icon>
  </button>
</div>
